import { NavLink, useLocation } from 'react-router-dom';
import '../styles/theme.css';

const LABELS = {
  'services': 'Services',
  'realisations': 'Réalisations',
  'catalogue': 'Catalogue',
  'produits': 'Catalogue',
  'agenda': 'Agenda',
  'qui-sommes-nous': 'Qui sommes-nous',
  'contact': 'Contact',
  'account': 'Mon compte',
};

export default function Breadcrumb() {
  const location = useLocation();
  const { pathname } = location;

  if (pathname === '/' || pathname.startsWith('/admin')) return null;

  const segments = pathname.split('/').filter(Boolean);

  const items = segments.map((seg, index) => {
    const decoded = decodeURIComponent(seg);
    let path = '/' + segments.slice(0, index + 1).join('/');

    // Si on est sur un produit (/produits/...), le lien "Catalogue" doit pointer vers /catalogue
    if (decoded === 'produits') {
      path = '/catalogue';
    }

    const label = LABELS[decoded]
      || decoded
        .replace(/-/g, ' ')
        .replace(/\//g, ' > ');
    return { path, label };
  });

  return (
    <nav
      className="breadcrumb"
      aria-label="Fil d'Ariane"
      style={{ margin: 0, maxWidth: 'none', padding: '8px 0' }}
    >
      <NavLink to="/" end className={() => ''}>Accueil</NavLink>
      {items.map(item => (
        <span key={item.path} className="breadcrumb-sep">
          <span aria-hidden="true">›</span>
          <NavLink to={item.path} className={() => ''}>{item.label}</NavLink>
        </span>
      ))}
    </nav>
  );
}
